// extracted by mini-css-extract-plugin
var _1 = "cjPPYhox7y";
export { _1 as "root" }
